// ESLINT-DISABLE: Старая реализация
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isInteger (x: any) {
  return typeof x === 'number' && isFinite(x) && Math.floor(x) === x
}
